import { GetDiscountCodes } from "@/server-types";
import { t } from "@lingui/core/macro";

export const getDiscountCodeStatusLabelAndColor = (
  status: GetDiscountCodes["response"]["discountCodes"][number]["status"],
) => {
  switch (status) {
    case "active":
      return { label: t`Aktivna`, color: "success" } as const;
    case "inactive":
      return { label: t`Neaktivna`, color: "warning" } as const;
    case "expired":
      return { label: t`Potekla`, color: "danger" } as const;
    case "deleted":
      return { label: t`Izbrisana`, color: "danger" } as const;
    case "scheduled":
      return { label: t`Načrtovana`, color: "warning" } as const;
    case "usage-limit-exceeded":
      return { label: t`Prekoračeno število uporab`, color: "danger" } as const;
    default:
      return { label: t`Neznano`, color: "default" } as const;
  }
};
